import { useClikArtPlacedIdsScan } from '@/api/hooks/use-clikart-placed-ids-scan'
import { useClikArtPlacedIdsSync } from '@/api/hooks/use-clikart-placed-ids-sync'

/**
 * Headless checker: once the first spread is up, reads which ClikArt is placed in the book (the
 * backend's cached scan), asks the backend to refresh that scan once per login, and keeps the
 * session's placement tracking in step with it — so the gallery's "Placed" badge and filter cover
 * spreads this session never opened. Lives here (like the font checkers) rather than as a home
 * group hook so the load-bearing group-hook call order in `home.tsx` stays untouched.
 */
export function ClikArtPlacedIdsSync({ isCheckpointLoaded }: { isCheckpointLoaded: boolean }) {
  useClikArtPlacedIdsSync(isCheckpointLoaded)
  useClikArtPlacedIdsScan(isCheckpointLoaded)

  return null
}
